module.exports = __webpack_public_path__ + "static/media/mail.80ebcf00.svg";